import { Checkbox, Collapse, Form, InputNumber, Select } from "antd";
import BbotAccordion from "top-component-library/BbotAccordion";

import { DEFAULT_PREFERENCE_OPTIONS, KDS_TICKET_ITEM_APPEARANCE_OPTIONS } from "../constants";

// Default Device Preferences: a checklist of on/off preferences plus two extra controls, all
// stored under the default_preferences blob. Keys the dialog never renders round-trip untouched
// (see mergeEditedConfig).
const DefaultPreferencesSection = () => (
  <BbotAccordion>
    <Collapse.Panel header="Default Device Preferences" key="default-preferences">
      {DEFAULT_PREFERENCE_OPTIONS.map((preference) => (
        <Form.Item
          key={preference.value}
          name={["default_preferences", preference.value]}
          valuePropName="checked"
          style={{ marginBottom: 8 }}
        >
          <Checkbox id={`dp-preference-${preference.value}`}>{preference.name}</Checkbox>
        </Form.Item>
      ))}
      <Form.Item
        name={["default_preferences", "kds_ticket_item_appearance"]}
        label="KDS Ticket Item Appearance"
        tooltip="Change the way that Order Items appear in the KDS Order Tickets. Expanded view will not show quantities and instead show each item separately even if they are identical."
      >
        <Select id="dp-kds-ticket-item-appearance" options={KDS_TICKET_ITEM_APPEARANCE_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["default_preferences", "kds_min_ticket_height"]}
        label="KDS View - Minimum Ticket Height (Max 1,000)"
        tooltip="Optional: Set the minimum height in pixels of the order tickets as they will appear on the KDS Screen."
      >
        <InputNumber id="dp-kds-min-ticket-height" min={0} max={1000} placeholder="Minimum Height" />
      </Form.Item>
    </Collapse.Panel>
  </BbotAccordion>
);

export default DefaultPreferencesSection;
